import { IReceptor, Receptor } from '@/shared/model/seguimiento/financiero/receptor.model';
import { TipoReceptor } from '@/shared/model/enumerations/tipo-receptor';
import { INomina, Nomina } from '@/shared/model/seguimiento/financiero/nomina.model';
import * as personaUtils from '@/shared/util/format-util';
import { ITabuladorUma, TabuladorUma } from '@/shared/model/seguimiento/financiero/tabulador-uma.model';
import { EventoPago, IEventoPago } from '@/shared/model/seguimiento/financiero/evento-pago.model';
import { EstadoPago } from '@/shared/model/enumerations/estado-pago';
import { CatalogoGenerico } from '@/shared/model/seguimiento/catalogo-generico.model';
import resolveEstadoPagoVariant from '@/shared/estados/estados-pago.util';
import { Beca } from '@/shared/model/seguimiento/beca.model';

export interface IPago {
  id?: string | null;
  tipoReceptor?: TipoReceptor | null;
  receptor?: Receptor | null;
  beca?: Beca | null;
  montoCalculado?: number | null;
  montoPercepciones?: number | null;
  montoDeducciones?: number | null;
  montoPago?: number | null;
  estadoActual?: EstadoPago | null;
  fechaPago?: Date | null;
  nombreCompleto?: string | null;
  nomina?: Nomina | null;
  claveNomina?: string | null;
  inicioPago?: Date | null;
  finPago?: Date | null;
  reportado?: boolean | null;
  tabuladorUma?: TabuladorUma | null;
  eventosPago?: Array<EventoPago> | null;
  conceptoPago?: CatalogoGenerico | null;
  activo?: boolean | null;
  incluido?: boolean | null;
  pagoOrigenId?: string | null;
  claveNominaInicial?: string | null;
  checked?: boolean | false;
  montoMonedaNacional?: number | null;
  comentariosRecuperacion?: string | null;
  fechaPagoDivisa?: Date | null;
  tipoCambio?: number | null;
  divisaColegiatura?: string | null;
}

export class Pago implements IPago {
  constructor(
    public id?: string | null,
    public tipoReceptor?: TipoReceptor | null,
    public receptor?: Receptor | null,
    public beca?: Beca | null,
    public montoCalculado?: number | null,
    public montoPercepciones?: number | null,
    public montoDeducciones?: number | null,
    public montoPago?: number | null,
    public estadoActual?: EstadoPago | null,
    public fechaPago?: Date | null,
    public nombreCompleto?: string | null,
    public nomina?: Nomina | null,
    public claveNomina?: string | null,
    public inicioPago?: Date | null,
    public finPago?: Date | null,
    public reportado?: boolean | null,
    public tabuladorUma?: TabuladorUma | null,
    public eventosPago?: Array<EventoPago> | null,
    public conceptoPago?: CatalogoGenerico | null,
    public activo?: boolean | null,
    public checked?: boolean | false,
    public incluido?: boolean | null,
    public pagoOrigenId?: string | null,
    public claveNominaInicial?: string | null,
    public montoMonedaNacional?: number | null,
    public comentariosRecuperacion?: string | null,
    public fechaPagoDivisa?: Date | null,
    public tipoCambio?: number | null,
    public divisaColegiatura?: string | null
  ) {}

  /**
   * Crea una instancia de Pago a partir de un objeto plano.
   * @param data Objeto que contiene los datos del pago.
   */
  static fromObject(data: IPago): Pago {
    const transformations = {
      eventosPago: (eventosPago: Array<IEventoPago>) => eventosPago.map(EventoPago.fromObject),
      receptor: (receptor: IReceptor) => Receptor.fromObject(receptor),
      nomina: (nomina: INomina) => Nomina.fromObject(nomina),
      tabuladorUma: (tabuladorUma: ITabuladorUma) => TabuladorUma.fromObject(tabuladorUma),
    };

    const pago = new Pago();
    for (const [key, value] of Object.entries(data)) {
      const transform = transformations[key as keyof IPago];
      pago[key] = transform ? transform(value) : value;
    }

    if (pago?.tipoReceptor === TipoReceptor.PENSIONISTA) {
      pago.nombreCompleto = personaUtils.fullName(pago.receptor);
    } else {
      pago.nombreCompleto = personaUtils.fullName(pago.receptor?.beca?.becario);
    }

    pago['variant'] = resolveEstadoPagoVariant(pago.estadoActual);
    return pago;
  }
}
